import { PageHeader } from "@/components/page-header";
import { useT } from "@/lib/i18n/use-t";
import { CombinedInstrumentsWrapper } from "./combined-instruments-wrapper";
import { T } from "./page.i18n";

export default function CombinedInstrumentsPage() {
  const t = useT(T);

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: t.settings, href: "/settings" }, { label: t.combinedInstruments }]}
        title={t.combinedInstruments}
        description={t.description}
      />

      <CombinedInstrumentsWrapper />
    </div>
  );
}
